import { mapValues } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Avatar from "../../../base/avatar/components/Avatar";
import { isLocalParticipantModerator } from "../../../base/participants";
import { changeDisplayOffline, changeDisplayOnline, fetchDataAttendance } from "../../actions.any";
import { getSortedParticipantIds } from "../../functions";
import { IconArrowDown, IconArrowUp, IconClear, IconVerified } from "../../../base/icons/svg";
import Icon from "../../../base/icons/components/Icon";
import { InputAdornment, TextField } from "@mui/material";
import { IconSearchParticipant } from "../../../moderator-controller/components/ModeratorControllerIcons";
import ClickableIcon from "../../../base/ui/components/web/ClickableIcon";
import VirtualList from "../../../chat/components/web/VirtualList";
const Attendance = (props) => {
    const dispatch = useDispatch();
    const { currentRoomId, dataAttendanceResponse } = props;
    const [contentSearch, setContentSearch] = useState("");
    const isLocalModerator = useSelector(isLocalParticipantModerator);
    const { dataAttendance } = useSelector((state) => state["features/participants-pane"]);
    const { remote: changeRemote, local: changeLocal } = useSelector((state) => state["features/base/participants"]);
    const { isDisplayOnline, isDisplayOffline } = useSelector((state) => state["features/participants-pane"]);
    const { local } = useSelector((state) => state["features/base/participants"]);
    const remoteObject = JSON.stringify(mapValues(Object.fromEntries(changeRemote), (obj) => ({
        name: obj.name,
        avatarURL: obj.avatarURL,
        email: obj.email,
    })));
    // get all jid in room
    const sortedParticipantIds = useSelector((state) => getSortedParticipantIds(state));
    // function convert character Viettnamese to English
    const toNonAccentVietnamese = (str) => {
        if (str) {
            str = str.replace(/A|Á|À|Ã|Ả|Ạ|Â|Ấ|Ầ|Ẫ|Ậ|Ă|Ắ|Ằ|Ẵ|Ặ/g, "A");
            str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
            str = str.replace(/E|É|È|Ẽ|Ẹ|Ê|Ế|Ề|Ễ|Ệ/, "E");
            str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
            str = str.replace(/I|Í|Ì|Ĩ|Ị/g, "I");
            str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
            str = str.replace(/O|Ó|Ò|Õ|Ọ|Ô|Ố|Ồ|Ỗ|Ộ|Ơ|Ớ|Ờ|Ỡ|Ợ/g, "O");
            str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
            str = str.replace(/U|Ú|Ù|Ũ|Ụ|Ư|Ứ|Ừ|Ữ|Ự/g, "U");
            str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
            str = str.replace(/Y|Ý|Ỳ|Ỹ|Ỵ/g, "Y");
            str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
            str = str.replace(/Đ/g, "D");
            str = str.replace(/đ/g, "d");
            // Some system encode vietnamese combining accent as individual utf-8 characters
            str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // Huyền sắc hỏi ngã nặng
            str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // Â, Ê, Ă, Ơ, Ư
        }
        return str;
    };
    const { t } = useTranslation();
    // const [dataAttendanceResponse, setDataAttendanceResponse] = useState({});
    // const fetchApiAttendance = async (roomId: any) => {
    //     const response = await apiManagerRoom.getAttendance(`?page=-1&roomId=${roomId}&isModerator=1`);
    //     setDataAttendanceResponse(response);
    // };
    // useEffect(() => {
    //     fetchApiAttendance(currentRoomId);
    // }, [sortedParticipantIds.length, isLocalModerator, local?.name]);
    useEffect(() => {
        dispatch(fetchDataAttendance(dataAttendanceResponse));
    }, [remoteObject, local?.name, local?.role]);
    useEffect(() => {
        dispatch(fetchDataAttendance(dataAttendanceResponse));
    }, [dataAttendanceResponse, local?.name]);
    const closeOnline = () => {
        dispatch(changeDisplayOnline(false));
    };
    const openOnline = () => {
        dispatch(changeDisplayOnline(true));
    };
    const closeOffline = () => {
        dispatch(changeDisplayOffline(false));
    };
    const openOffline = () => {
        dispatch(changeDisplayOffline(true));
    };
    // sort descending
    const compareDuration = (a, b) => {
        if (a.duration > b.duration) {
            return -1;
        }
        if (a.duration < b.duration) {
            return 1;
        }
        return 0;
    };
    // calculator duration
    //   const calculatorDuration = (timeDetails: any[]) => {
    //     return timeDetails?.reduce((acc: number, cd: any) => {
    //       if(cd.ended_time === null) {
    //         return acc + ((new Date()) - new Date(cd.started_time))
    //       }
    //       return acc + (new Date(cd.ended_time) - new Date(cd.started_time))
    //     }, 0)
    //   }
    const calculatorDuration = (timeDetails) => {
        return timeDetails?.reduce((acc, cd) => {
            const startTime = new Date(cd.started_time).getTime();
            const endTime = cd.ended_time ? new Date(cd.ended_time).getTime() : Date.now();
            return acc + (endTime - startTime);
        }, 0);
    };
    // add duration to array dataAttendance
    const dataAttendanceAddDuration = dataAttendance?.map((item) => (item.duration = calculatorDuration(item.timeDetails)));
    // list user active
    const dataAttendanceActive = dataAttendance?.filter((item) => item?.onRoom === 1)?.sort(compareDuration);
    // list user offline
    const dataAttendanceOffline = dataAttendance?.filter((item) => item?.onRoom === 0)?.sort(compareDuration);
    // function convert seconds to "hh:mm"
    const toHoursAndMinutes = (totalSeconds) => {
        const totalMinutes = Math.floor(totalSeconds / 60);
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        const count = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
        return count;
    };
    // search list user active
    const dataAttendanceActiveSearch = dataAttendanceActive?.map((item) => {
        const displayName = toNonAccentVietnamese(item?.displayName)?.toLowerCase();
        const mail = toNonAccentVietnamese(item?.email)?.toLowerCase();
        if (contentSearch?.trim()?.length > 0) {
            if (displayName?.includes(toNonAccentVietnamese(contentSearch?.trim())?.toLowerCase()) ||
                mail?.includes(toNonAccentVietnamese(contentSearch?.trim())?.toLowerCase())) {
                return item;
            }
        }
        else {
            if (displayName?.includes(toNonAccentVietnamese('')?.toLowerCase()) ||
                mail?.includes(toNonAccentVietnamese('')?.toLowerCase())) {
                return item;
            }
        }
    });
    const dataAttendanceActiveSearchFilter = dataAttendanceActiveSearch?.filter((item) => item !== undefined);
    // search list user offline
    const dataAttendanceOfflineSearch = dataAttendanceOffline?.map((item) => {
        const displayName = toNonAccentVietnamese(item?.displayName)?.toLowerCase();
        const mail = toNonAccentVietnamese(item?.email)?.toLowerCase();
        if (contentSearch?.trim()?.length > 0) {
            if (displayName?.includes(toNonAccentVietnamese(contentSearch?.trim())?.toLowerCase()) ||
                mail?.includes(toNonAccentVietnamese(contentSearch?.trim())?.toLowerCase())) {
                return item;
            }
        }
        else {
            if (displayName?.includes(toNonAccentVietnamese('')?.toLowerCase()) ||
                mail?.includes(toNonAccentVietnamese('')?.toLowerCase())) {
                return item;
            }
        }
    });
    const dataAttendanceOfflineSearchFilter = dataAttendanceOfflineSearch?.filter((item) => item !== undefined);
    const checkEmail = (email) => {
        if (email.includes('.guest')) {
            return false;
        }
        else {
            return true;
        }
    };
    const parentElementRef = useRef(null);
    const [heightActiveUserVirtual, setHeightActiveUserVitrtual] = useState(parentElementRef?.current?.getBoundingClientRect()?.height || 1);
    const [heightInActiveUserVirtual, setHeightInActiveUserVitrtual] = useState(parentElementRef?.current?.getBoundingClientRect()?.height || 1);
    useEffect(() => {
        if (dataAttendanceActiveSearchFilter?.length < 6) {
            setHeightActiveUserVitrtual(dataAttendanceActiveSearchFilter.length * 53);
        }
        else {
            setHeightActiveUserVitrtual((parentElementRef?.current?.getBoundingClientRect()?.height || 1) * 55 / 100);
        }
    }, [dataAttendanceActiveSearchFilter?.length]);
    useEffect(() => {
        if (dataAttendanceOfflineSearchFilter?.length < 5) {
            setHeightInActiveUserVitrtual(dataAttendanceOfflineSearchFilter.length * 53);
        }
        else {
            setHeightInActiveUserVitrtual((parentElementRef?.current?.getBoundingClientRect()?.height || 1) * 30 / 100);
        }
    }, [dataAttendanceOfflineSearchFilter?.length]);
    return (React.createElement("div", { className: "attendance-container", style: {
            paddingLeft: "16px",
            marginTop: "25px",
            marginRight: "25px",
            overflowY: "auto",
            overflowX: "hidden",
            height: "calc(100% - 125px)",
        } },
        React.createElement(TextField, { "data-size": 'normal', autoFocus: false, fullWidth: true, placeholder: t("attendance.placeholderSearch"), value: contentSearch, onChange: (e) => setContentSearch(e.target.value), InputProps: {
                startAdornment: (React.createElement(InputAdornment, { position: 'start' },
                    React.createElement(IconSearchParticipant, null))),
                endAdornment: (React.createElement(React.Fragment, null, contentSearch.length > 0 &&
                    React.createElement(InputAdornment, { position: 'end' },
                        React.createElement(ClickableIcon, { accessibilityLabel: 'clear-input', icon: IconClear, onClick: () => setContentSearch(''), className: 'icon-input', onKeyPress: (e) => {
                                if (e?.key === 'Enter')
                                    setContentSearch('');
                            } }))))
            } }),
        React.createElement("div", { ref: parentElementRef, style: { height: "calc(100% - 50px)", overflowY: "auto", overflowX: "hidden", paddingRight: '5px' } },
            dataAttendanceActiveSearchFilter?.length > 0 && (React.createElement("div", { style: { position: "relative", top: "8px" } },
                React.createElement("div", { style: { display: "flex", justifyContent: "space-between", height: '48px', alignItems: 'center' } },
                    React.createElement("div", { style: {
                            color: "#44494D",
                            width: "fit-content",
                            background: "#fff",
                            fontWeight: "700",
                            fontSize: "16px",
                        } },
                        t("attendance.active"),
                        " (",
                        dataAttendanceActiveSearchFilter?.length,
                        ")"),
                    isDisplayOnline ? (React.createElement(Icon, { onClick: () => closeOnline(), style: { cursor: "pointer" }, src: IconArrowUp, size: 18, color: "#44494D" })) : (React.createElement(Icon, { onClick: () => openOnline(), style: { cursor: "pointer" }, src: IconArrowDown, size: 18, color: "#44494D" }))),
                isDisplayOnline && (React.createElement("div", { style: { padding: "0 0 0 8px" } },
                    React.createElement(VirtualList, { items: dataAttendanceActiveSearchFilter, height: heightActiveUserVirtual, estimatedItemHeight: 63, renderItem: (item, index) => (React.createElement("div", { style: {
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                margin: "8px 0",
                            } },
                            React.createElement("div", { style: { display: "flex" } },
                                React.createElement("div", { style: { position: 'relative' } },
                                    React.createElement(Avatar, { displayName: item?.displayName || item?.name, size: 32, avatarUrl: item?.images }),
                                    checkEmail(item?.email) && React.createElement(Icon, { style: { position: 'absolute', bottom: "4px", left: "19px" }, src: IconVerified, size: 12, color: 'transparent' })),
                                React.createElement("div", { style: { display: "flex", flexDirection: "column", marginLeft: "16px" } },
                                    React.createElement("div", { style: {
                                            color: "#000",
                                            fontSize: "14px",
                                            width: "160px",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: 'nowrap'
                                        } }, item.displayName || item?.username),
                                    React.createElement("div", { style: { color: "#8F9294", fontSize: "12px" } }, item?.participantType === "none"
                                        ?
                                            t("attendance.walkInGuest")
                                        :
                                            (item?.participantType === "owner"
                                                ?
                                                    t("attendance.owner")
                                                :
                                                    (item?.participantType === "host"
                                                        ?
                                                            t("attendance.host")
                                                        :
                                                            (item?.participantType === "coHost"
                                                                ?
                                                                    t("attendance.coHost")
                                                                :
                                                                    t("attendance.guest"))))))),
                            React.createElement("div", { style: { color: "#73777A", fontSize: "14px", fontWeight: '500' } }, Math.floor(calculatorDuration(item?.timeDetails) / 60000) < 1
                                ? "< 00:01"
                                : toHoursAndMinutes(Math.floor(calculatorDuration(item?.timeDetails) / 1000))))) }))))),
            dataAttendanceOfflineSearchFilter?.length >= 0 && (React.createElement("div", { style: { position: "relative", top: "16px" } },
                React.createElement("div", { style: { display: "flex", justifyContent: "space-between", height: '48px', alignItems: 'center' } },
                    React.createElement("div", { style: {
                            color: "#44494D",
                            width: "fit-content",
                            background: "#fff",
                            fontWeight: "700",
                            fontSize: "16px",
                        } },
                        t("attendance.inactive"),
                        " (",
                        dataAttendanceOfflineSearchFilter?.length,
                        ")"),
                    dataAttendanceOfflineSearchFilter?.length > 0 &&
                        ((isDisplayOffline) ? (React.createElement(Icon, { onClick: () => closeOffline(), style: { cursor: "pointer" }, src: IconArrowUp, size: 18, color: "#44494D" })) : (React.createElement(Icon, { onClick: () => openOffline(), style: { cursor: "pointer" }, src: IconArrowDown, size: 18, color: "#44494D" })))),
                isDisplayOffline && (React.createElement("div", { style: { padding: "0 0 0 8px" } },
                    React.createElement(VirtualList, { items: dataAttendanceOfflineSearchFilter, height: heightInActiveUserVirtual, estimatedItemHeight: 63, renderItem: (item, index) => (React.createElement("div", { style: {
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                margin: "8px 0",
                            } },
                            React.createElement("div", { style: { display: "flex" } },
                                React.createElement("div", { style: { position: 'relative' } },
                                    React.createElement(Avatar, { displayName: item?.displayName || item?.name, size: 32, avatarUrl: item?.images }),
                                    checkEmail(item?.email) && React.createElement(Icon, { style: { position: 'absolute', bottom: "4px", left: "19px" }, src: IconVerified, size: 12, color: 'transparent' })),
                                React.createElement("div", { style: { display: "flex", flexDirection: "column", marginLeft: "16px" } },
                                    React.createElement("div", { style: {
                                            color: "#000",
                                            fontSize: "14px",
                                            width: "160px",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: 'nowrap'
                                        } }, item.displayName || item?.username),
                                    React.createElement("div", { style: { color: "#8F9294", fontSize: "12px" } }, item?.participantType === "none"
                                        ?
                                            t("attendance.walkInGuest")
                                        :
                                            (item?.participantType === "owner"
                                                ?
                                                    t("attendance.owner")
                                                :
                                                    (item?.participantType === "host"
                                                        ?
                                                            t("attendance.host")
                                                        :
                                                            (item?.participantType === "coHost"
                                                                ?
                                                                    t("attendance.coHost")
                                                                :
                                                                    t("attendance.guest"))))))),
                            React.createElement("div", { style: { color: "#73777A", fontSize: "14px", fontWeight: '500' } }, Math.floor(calculatorDuration(item?.timeDetails) / 60000) < 1
                                ? "< 00:01"
                                : toHoursAndMinutes(Math.floor(calculatorDuration(item?.timeDetails) / 1000))))) }))))),
            dataAttendanceActiveSearchFilter?.length <= 0 && dataAttendanceOfflineSearchFilter?.length <= 0 && (React.createElement("div", { style: { fontSize: "16px", color: "#000", marginTop: '0.5rem' } }, t("dialog.participantNotFoundError"))))));
};
export default Attendance;
